import { AppThunk, AppDispatch } from "../../types";
import handleResponse from "../../../shared/handleResponse";
import { push } from "connected-react-router";
import { ROOT_PATH } from "../../../routing/paths";
import { SET_AUTH } from "..";

type VerifySessionSuccessParams = { jwt: string; role: string };
export type VerifySession = () => void;

const verifySessions = (): AppThunk => async (dispatch: AppDispatch) => {
  const jwt = localStorage.getItem("jwt");
  const onSuccess = ({ jwt, role }: VerifySessionSuccessParams) => {
    localStorage.setItem("token", jwt);
    dispatch({ type: SET_AUTH, payload: { logged: true, role } });
  };

  if (jwt) await handleResponse("put", "/sessions/verify", onSuccess, dispatch);
  else dispatch(push(ROOT_PATH));
};

export default verifySessions;
